import React from 'react';
import { Registry } from 'react-registry';

import ViewProvider from '../ViewProvider';

/**
 * @overview if view ID specified
 *
 * @author chris
 */

export interface IContainerViewProps {
	viewId?: string;
	viewKey?: string;
}

export enum ContainerViewIds {
	NONE = "none"
}

export const ContainerViewProvider: React.SFC<IContainerViewProps> = (props) => {
	if (props.viewId && props.viewId !== ContainerViewIds.NONE && Registry.get({id: props.viewId, registry: "views"})) {
		return (
			<ViewProvider viewId={props.viewId} viewKey={props.viewKey}>
				{props.children}
			</ViewProvider>
		);
	} else {
		return (
			<React.Fragment>
				{props.children}
			</React.Fragment>
		);
	}
};

export default ContainerViewProvider;



// WEBPACK FOOTER //
// ./src/core/components/containerViewProvider/ContainerViewProvider.tsx